import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { Box, Button, Text, Stack } from '@machobear/design-system'
import useGetPlanKey from '@/hooks/use-get-plan-key'

const Empty = ({ isNotEssentials }: { isNotEssentials: boolean }) => {
  const { t } = useTranslation()
  const planText = useGetPlanKey()

  return (
    <Stack align="left" space="xsmall">
      {isNotEssentials && (
        <Text weight="medium" size="medium" tone="secondary">
          {t('l.usage.credits.purchased.title', 'Purchased')}
        </Text>
      )}
      <Box
        display="flex"
        flexDirection="column"
        gap="gutter"
        padding="gutter"
        alignItems="center"
        justifyContent="center"
        borderRadius="small"
        boxShadow="borderNeutralLight"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap="xxsmall"
        >
          <Text weight="strong" size="large" tone="secondary" baseline={false}>
            {t('l.usage.credits.no_products.title', 'No products added')}
          </Text>
          <Text tone="secondary" baseline={false} size="small">
            {t(
              'l.usage.credits.no_products.subtitle',
              'You don’t have any products in your account.'
            )}
          </Text>
        </Box>
        <NavLink
          to="/usage-credits/products/all"
          id={`usage-credit-${planText}-no-products-browse-products-btn-click`}
        >
          <Button size="small">{t('l.usage.credits.no_products.browse', 'Browse products')}</Button>
        </NavLink>
      </Box>
    </Stack>
  )
}

export default Empty
